export default {
  sections: {
    header: {
      title: 'Create AI Music in seconds',
      description:
        'Select a genre, mood, or theme to instantly generate AI-powered music!',
    },
    errorMessage:
      'An unexpected error occurred. Please reload the page to try again.',
  },
  headerTiles: {
    titles: {
      generateMusic: 'AI Music Generator',
      textToMusic: 'AI Text to Music',
      browseRoyaltyFree: 'Royalty-Free music templates',
      distributeMusic: 'Distribute Your Music',
    },
    subtitle: {
      generateMusic: 'Generate Music',
      browseTemplates: 'Browse Templates',
      createNewRelease: 'Create New Release',
    },
  },
  discoveryBanner: {
    title: 'Sample Packs',
    subTitle: 'Download Sample Packs from any Loudly track to use in your DAW',
    learnMore: 'Learn more',
    ctaGenerateMusic: 'GENERATE TRACK TO DOWNLOAD',
    ctaNoAccount: 'START FREE NOW',
  },
  generate: 'Generate',
};
